<template>
    <section class="section-padding" id="training">
      <div class="container-fluid container-lg">
        <div class="row justify-content-center align-items-center">
          <div class="col-12 col-md-10 mx-auto text-center">
                <div class="training-text">
                    <h2>Become a Professional Software Developer</h2>
                  <div class="mt-4">
                    <p>Get up your software development journey faster by enrolling for a top-notch training from experts of strong years of experience.</p>
                  </div>
                  <div class="pt-4">
                    <a href="/enroll" class="training-button">Enroll Now</a>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>  
  export default {
    
  }
  </script>
  
  <style>
  #training {
    background-image: url("../assets/trainingbg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  #training.section-padding {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}
  
  #training::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: var(--dacode-primary-color) !important;
    opacity: .9;
  }
  
  #training, .training-text {
    position: relative;
    z-index: 10;
  }
  
  #training h2{
    color: var(--dacode-secondary-color);
    font-size: 2rem;
    text-align: center;
  }
  
  #training p {
    font-size: 1rem;
    color: var(--dacode-white-color);
    letter-spacing: 2px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.92);
  }
  
  .training-button {
    background-color: var(--dacode-secondary-color) !important;
    padding: 1rem 3rem;
    color: var(--dacode-white-color) !important;
    border: 2.5px solid var(--dacode-secondary-color);
    border-radius: 1000px;
  }
  </style>
  
  